<template>
  <ion-card>
    <ion-card-header>
      <h2>Smartbox Token</h2>
    </ion-card-header>
    <ion-card-content>
      <copyable-code :code="token" />
    </ion-card-content>
  </ion-card>
</template>

<script>
import CopyableCode from '../../common/CopyableCode'

export default {
  components: {
    CopyableCode
  },
  props: {
    token: {
      type: String,
      required: true
    }
  }
}
</script>